// src/pages/SettingsPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UpgradeModal from '../components/UpgradeModal';
import './SettingsPage.css';

const PLAN_INFO = {
  none: { name: 'Free', color: '#6b7280' },
  pro: { name: 'Pro', color: '#8b5cf6' }
};

const STATUS_LABELS = {
  none: "No subscription",
  on_trial: "Free trial",
  active: "Active",
  past_due: "Payment overdue",
  paused: "Paused",
  cancelled: "Cancelled",
  expired: "Expired"
};

const SettingsPage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const handleManageBilling = () => {
    if (currentUser?.plan === 'none' || !currentUser?.plan) {
      // Si l'utilisateur n'a pas de plan, ouvrir le modal
      setShowUpgradeModal(true);
    } else {
      // Sinon, rediriger vers la page de facturation
      navigate('/dashboard/billing');
    }
  };

  const planInfo = PLAN_INFO[currentUser?.plan || 'none'];
  const statusLabel = STATUS_LABELS[currentUser?.subscriptionStatus] || currentUser?.subscriptionStatus;

  return (
    <div className="settings-page">
      {/* Subscription Section */}
      <div className="settings-subscription-section">
        <h2>Subscription</h2>
        <div className="settings-subscription-card">
          <div className="settings-subscription-info">
            <div className="settings-subscription-plan">
              <span className="settings-plan-badge" style={{ backgroundColor: planInfo.color }}>
                {planInfo.name}
              </span>
              {currentUser?.subscriptionStatus && currentUser.subscriptionStatus !== 'none' && (
                <span className="settings-status-text">{statusLabel}</span>
              )}
            </div>
            {currentUser?.plan === 'none' || !currentUser?.plan ? (
              <p className="settings-subscription-description">
                {currentUser?.subscriptionStatus === 'on_trial'
                  ? 'You are on a free trial. Subscribe to continue after the trial ends.'
                  : 'No active subscription. Subscribe to access all features.'}
              </p>
            ) : (
              <p className="settings-subscription-description">
                You have access to all features of the {planInfo.name} plan.
              </p>
            )}
          </div>
          <button
            onClick={handleManageBilling}
            className="settings-manage-btn"
          >
            {currentUser?.plan === 'none' || !currentUser?.plan ? 'View Plans' : 'Manage Subscription'}
          </button>
        </div>
      </div>

      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />

    </div>
  );
};

export default SettingsPage;
